import React, { useState, useEffect, useRef } from 'react';
import { FaPlay, FaPause, FaShareAlt } from 'react-icons/fa';
import { BASE_WEB_URL } from '../../config';
import { FcLike, FcLikePlaceholder } from 'react-icons/fc';
import { ShareBar } from "./ShareBar";
import { FiMoreHorizontal } from "react-icons/fi";

const AudioPlayer = (props) => {
	const [currentTime, setCurrentTime] = useState('0:00');
	const [totalTime, setTotalTime] = useState('3:00');
 	const [currentSong, setCurrentSong] = useState({
		tokenId: props.tokenId === undefined ? "" : props.tokenId,
		name: props.name === undefined ? "" : props.name, 
		author: props.author, 
		img: props.imageBase64 === undefined ? "" : props.imageBase64, 
		audio: props.audio, 
	})
	const [pause, setPause] = useState(false);
	const [isFavour, setIsFavour] = useState(props.isFavour);
	const [favours, setFavours] = useState(props.favours);
	const [sptAddress, setSptAddress] = useState(props.sptAddress);
	const [sptMyBalance, setSptMyBalance] = useState(props.sptMyBalance);
	const [sptBalance, setSptBalance] = useState(props.sptBalance);

	const [shareButtonsStyle, setShareButtonsStyle] = useState({
		display: 'none', 
		position: 'absolute', 
		marginTop: '-70px', 
		marginLeft: '-13px',
		backgroundColor: 'white',
		borderRadius: '5px',
		borderWidth: '1px',
		borderColor: '#ccc',
		padding: '5px',
	});

	const playerRef = useRef();
	const timelineRef = useRef();
	const playheadRef = useRef();
	const hoverPlayheadRef = useRef();
  
	useEffect(() => {
		playerRef.current.removeEventListener("timeupdate", timeUpdate);
		playerRef.current.removeEventListener("loadedmetadata", onAudioLoad);
    timelineRef.current.removeEventListener("click", changeCurrentTime);
    timelineRef.current.removeEventListener("mousemove", hoverTimeLine);
    timelineRef.current.removeEventListener("click", resetTimeLine);

		playerRef.current.addEventListener("timeupdate", timeUpdate, false);
		playerRef.current.addEventListener("loadedmetadata", onAudioLoad, false);
		timelineRef.current.addEventListener("click", changeCurrentTime, false);
		timelineRef.current.addEventListener("mousemove", hoverTimeLine, false);
		timelineRef.current.addEventListener("mouseout", resetTimeLine, false);
	}, [])

	useEffect(() => {
		if(props === undefined) return;
		setCurrentSong({
			tokenId: props.tokenId === undefined ? "" : props.tokenId,
			name: props.name === undefined ? "" : props.name, 
			author: props.author, 
			img: props.imageBase64 === undefined ? "" : props.imageBase64, 
			audio: props.audio, 
		});
		setIsFavour(props.isFavour === undefined ? false : props.isFavour);
		setFavours(props.favours === undefined ? "0": props.favours);
		setSptAddress(props.sptAddress);
		setSptMyBalance(props.sptMyBalance);
		setSptBalance(props.sptBalance);
	}, [props])

	const changeCurrentTime = (e) => {
		const duration = playerRef.current.duration;

		const playheadWidth = timelineRef.current.offsetWidth;
		const offsetWidht = timelineRef.current.offsetLeft;
		const userClickWidht = e.clientX - offsetWidht;
	
		const userClickWidhtInPercent = (userClickWidht*100)/playheadWidth;

		playheadRef.current.style.width = userClickWidhtInPercent + "%";
		playerRef.current.currentTime = (duration * userClickWidhtInPercent)/100;
	}

	const hoverTimeLine = (e) => {
		const duration = playerRef.current.duration;

		const playheadWidth = timelineRef.current.offsetWidth
		
		const offsetWidht = timelineRef.current.offsetLeft;
		const userClickWidht = e.clientX - offsetWidht;
		const userClickWidhtInPercent = (userClickWidht*100)/playheadWidth;

		if(userClickWidhtInPercent <= 100){
			hoverPlayheadRef.current.style.width = userClickWidhtInPercent + "%";
		}
		
		const time = (duration * userClickWidhtInPercent)/100;
		
		if( (time >=0) && (time <= duration)){
			hoverPlayheadRef.current.dataset.content = formatTime(time);
		}
	}

	const showShareButtons = () => {
		_showShareButtons(shareButtonsStyle.display === 'none');
	}

	const _showShareButtons = (bl) => {
		if(bl) {
			setShareButtonsStyle({
				...shareButtonsStyle,
				display: 'block',
				zIndex: 99999,
			})
		} else {
			setShareButtonsStyle({
				...shareButtonsStyle,
				display: 'none',
			})
		}
	}

	const resetTimeLine = () => {
		hoverPlayheadRef.current.style.width = 0;
	}

	const onAudioLoad = () => {
		const duration = playerRef.current.duration;
		setTotalTime(formatTime(duration));
	}

	const timeUpdate = () => {
		const duration = playerRef.current.duration;
		const timelineWidth = timelineRef.current.offsetWidth - playheadRef.current.offsetWidth;
		const playPercent = 100 * (playerRef.current.currentTime / duration);
		playheadRef.current.style.width = playPercent + "%";
		const currentTime = formatTime(parseInt(playerRef.current.currentTime));  
		setCurrentTime(currentTime);
	}

	const formatTime = (currentTime) =>{
		const minutes = Math.floor(currentTime / 60);
		let seconds = Math.floor(currentTime % 60);
		seconds = (seconds >= 10) ? seconds : "0" + seconds % 60;
		const formatTime = minutes + ":" +  seconds
		return formatTime;
	}

  const playOrPause = () =>{
    // const audio = new Audio(currentSong.audio);
    if( pause ){
			props.setCurrentPlayingId(true);
      playerRef.current.play();
    }else{
			props.setCurrentPlayingId(false);
			playerRef.current.pause();
    }
		setPause(!pause);
  }

	useEffect(() => {
		// console.log("isPlay", props.isPlay)
		if(!props.isPlay) {
			playerRef.current.pause();
			setPause(!props.isPlay);
		} 
	}, [props.isPlay])

	const favor = () => {
		if(!isFavour) props.addFavour();
		else props.removeFavour();
	}

	return (
		<div className="card">
			<div className="current-song">
				<audio
					ref={playerRef}
					src={ currentSong === undefined || currentSong.audio === undefined ? "" : currentSong.audio }
				/>
				
				<div className="img-wrap">
					<img src={ currentSong.img } alt="photo"/>
				</div>
				{props.commingsoon &&
					<img style={{marginTop: '-250px', paddingLeft: '50%', paddingTop: '50%', zIndex: 0}} src={"/images/unsupportable.png"} alt=""/>
				}
				<button 
					onClick={playOrPause} 
					className="play" 
					style={{marginTop: "75px", position: "absolute", color: "#000000c0", width: "100px", height: "100px", borderRadius: "200px", backgroundColor: "#ffffff50"}}>
					{
						(!props.isPlay) ? <FaPlay style={{margin: "auto"}} size="30"/>
						: <FaPause style={{margin: "auto"}} size="30"/>
					}
				</button>
				<input type="hidden" value={ "token id: " + currentSong.tokenId }/>
				<span className="song-name">{ currentSong.name }</span>
				<span className="song-autor">{ currentSong.author }</span>
				
				<div className="time">
					<div className="current-time">{ currentTime }</div>
					<div className="end-time">{ totalTime }</div>
				</div>
				
				<div ref={timelineRef} id="timeline">
					<div ref={playheadRef} id="playhead"></div>
					<div ref={hoverPlayheadRef} className="hover-playhead" data-content="0:00"></div>
				</div>
				
				<div className="controls">
					<div style={shareButtonsStyle}>
						<ShareBar 
							url={BASE_WEB_URL + 'id/' + currentSong.tokenId}
							onDone={() => _showShareButtons(false)}/>
					</div>

					<button onClick={showShareButtons} className="prev prev-next">
						<FaShareAlt style={{margin: "auto"}}/>
					</button> 
					
					<button className="more" onClick={() => {props.openDetail()}}>
						<FiMoreHorizontal size={30}/>
					</button>
					{/* <button 
						onClick={playOrPause} 
						className="play" 
					>
						{
							(!pause) ? <FaPlay style={{margin: "auto"}}/>
							: <FaPause style={{margin: "auto"}}/>
						}
					</button> */}

					<button onClick={() => favor()} className="next prev-next">
						{
							isFavour ? (
								<div style={{display: "flex"}}>
									<FcLike style={{margin: "auto"}}/>
									<div style={{fontSize: '9px'}}>{favours === undefined ? "0" : favours}</div>
								</div>
							) : (
								<div style={{display: "flex"}}>
									<FcLikePlaceholder style={{margin: "auto"}} />
									<div style={{fontSize: '9px'}}>{favours === undefined ? "0" : favours}</div>
								</div>
							)
						}
					</button>
				</div>
				<button className="info">
					<div>{sptAddress}</div>
					<div>{sptMyBalance + "/" + sptBalance}</div>
				</button>

			</div>
		</div>
	)
}
export default AudioPlayer;
